import { Eyebrow, PrimaryButton, Reveal } from "@/components/ui-bits";

const Intro = () => {
  return (
    <section data-testid="intro-section" aria-labelledby="intro-heading" className="bg-white py-16 sm:py-20 lg:py-24">
      <div className="container-30 grid gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <Eyebrow>Transportation Built Around Your Business</Eyebrow>
          <h2
            id="intro-heading"
            data-testid="intro-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl lg:text-5xl"
          >
            TRANSPORTATION BUILT FOR YOUR BUSINESS.
          </h2>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-7">
          <div className="max-w-2xl lg:pt-14">
            <p className="text-base leading-relaxed text-[#191c1e]/80 sm:text-lg">
              Every shipment has different requirements. The right transportation solution starts with your freight,
              schedule and delivery needs.
            </p>
            <ul className="mt-7 space-y-3" data-testid="intro-service-bullets">
              {["FTL (Full Truckload) Transportation", "Dedicated Service", "Expedited Delivery", "White Glove Delivery"].map((item) => (
                <li key={item} className="flex items-center gap-4">
                  <span className="block h-1.5 w-1.5 shrink-0 bg-[#ff6a00]" aria-hidden="true" />
                  <span className="text-base font-semibold tracking-wide text-[#191c1e]">{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-10">
              <PrimaryButton to="/capacity" testid="intro-cta">
                HOW WE MOVE FREIGHT
              </PrimaryButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Intro;
